// TODO(daniel): Removed Flow for now. It was getting in the way.
import type { Plan } from "Utils/types";

export const ADD_PLAN_TO_CART = "cart_service/ADD_PLAN_TO_CART";
export const ADD_UPGRADE_OPTION = "cart_service/ADD_UPGRADE_OPTION";
export const REMOVE_UPGRADE_OPTION = "cart_service/REMOVE_UPGRADE_OPTION";
export const ADD_PACKAGE_TO_CART = "cart_service/ADD_PACKAGE_TO_CART";
export const CART_UPDATE_SUCCESS = "cart_service/CART_UPDATE_SUCCESS";
export const UPDATE_CART_RELATED_PLAN_IDS = "cart_service/UPDATE_CART_RELATED_PLAN_IDS";
export function addPlanToCart({
  planType,
  plan,
  tracking = {},
  shouldClearDentalVision = false,
  continueToCart = false,
  url = null,
  shouldClearLife = false,
} = {}) {
  plan = plan || {};
  return {
    type: ADD_PLAN_TO_CART,
    planID: plan.id || null,
    planType,
    shouldClearDentalVision,
    continueToCart,
    url,
    shouldClearLife,
    meta: {
      analytics: {
        type: ADD_PLAN_TO_CART,
        plan_id: plan.id,
        plan_type: planType,
        name: plan.raw_name,
        brand: plan.carrier,
        total_cost: plan.total_cost,
        average_cost: plan.average_monthly_premium,
        network: plan.plan_type,
        deductible: plan.deductible,
        doctor_visits: (plan.estimated_costs || {}).pcp_visit,
        hospitalization: (plan.estimated_costs || {}).hospitalization,
        generic_drugs: (plan.estimated_costs || {}).generic_drugs,
        deprecatedName: "SelectedPlan",
        deprecatedLabel: null,
        deprecatedValue: null,
        ...tracking,
      },
    },
  };
}
// Upgrade Options are always medical plans.
// It shouldn't remove any plans in the cart.
export const addUpgradeOption = (plan: Plan) => ({
  type: ADD_UPGRADE_OPTION,
  planID: plan.id,
  meta: {
    analytics: {
      type: ADD_UPGRADE_OPTION,
      plan_id: plan.id,
      plan_type: "medical",
      name: plan.raw_name,
      brand: plan.carrier,
      total_cost: plan.total_cost,
      average_cost: plan.average_monthly_premium,
      network: plan.plan_type,
      deductible: plan.deductible,
      doctor_visits: (plan.estimated_costs || {}).pcp_visit,
      hospitalization: (plan.estimated_costs || {}).hospitalization,
      generic_drugs: (plan.estimated_costs || {}).generic_drugs,
      deprecatedName: "SelectedPlan",
      deprecatedLabel: null,
      deprecatedValue: null,
    },
  },
});
export const removeUpgradeOption = (plan: Plan) => ({
  type: REMOVE_UPGRADE_OPTION,
  planID: plan.id,
  meta: {
    analytics: {
      type: ADD_UPGRADE_OPTION,
      plan_id: plan.id,
      plan_type: "medical",
      name: plan.raw_name,
      brand: plan.carrier,
      total_cost: plan.total_cost,
      average_cost: plan.average_monthly_premium,
      network: plan.plan_type,
      deductible: plan.deductible,
      doctor_visits: (plan.estimated_costs || {}).pcp_visit,
      hospitalization: (plan.estimated_costs || {}).hospitalization,
      generic_drugs: (plan.estimated_costs || {}).generic_drugs,
      deprecatedName: "SelectedPlan",
      deprecatedLabel: null,
      deprecatedValue: null,
    },
  },
});
export const addPackageToCart = (planIds: Array<string>) => ({
  type: ADD_PACKAGE_TO_CART,
  planIds,
  continueToCart: true,
  meta: {
    analytics: {},
  },
});
export const cartUpdateSuccess = (originalAction) => ({
  type: CART_UPDATE_SUCCESS,
  payload: {
    originalAction,
  },
});
export const updateCartRelatedPlanIDs = (relatedCartPlanIds: Array<string>) => ({
  type: UPDATE_CART_RELATED_PLAN_IDS,
  relatedCartPlanIds,
});
